module.exports = __webpack_public_path__ + "img/product-packaging-erp.ca8133ef.png";